'use client'
import { useParams } from 'next/navigation'

import { AccountNotFoundPage } from '~/components/AccountNotFoundPage'
import { SmartAccountDetail } from '~/components/account-detail/SmartAccountDetail'
import { IAddress } from '~/types'
import { EvmAddress } from '~/utils/address'

export function Account() {
  let address: IAddress
  try {
    const { account } = useParams<{ account: string }>()
    address = EvmAddress.format(account)
  } catch {
    // invalid address format
    throw new Error('Invalid address format')
  }

  if (!address) {
    return <AccountNotFoundPage address={address} />
  }

  return <SmartAccountDetail address={address} />
}
